import React from 'react';
import styles from './LinkToArea.styles';
import { useDispatch, useSelector } from 'react-redux';
import { selectCategory } from '../../redux/store/userData/categories';
import { VehicleCategoryData } from '../../@types';
import { selectSelectedDrawersCount } from '../../redux/store/ui/common';
import { ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

interface Props {
  text?: string;
  category?: VehicleCategoryData | null;
  params?: any;
}

const LinkToCategory: React.FC<Props> = ({ text, category }) => {
  const dispatch = useDispatch();
  const openedDrawersCount = useSelector(selectSelectedDrawersCount);

  if (!category) {
    return <span>{text}</span>;
  }

  const onClickHandler = (e: any) => {
    e.preventDefault();
    if (category != null && openedDrawersCount < 2) {
      dispatch(selectCategory(category));
    }
  };
  return (
    <>
      {openedDrawersCount < 2 ? (
        <span className="link" onClick={onClickHandler}>
          {text || '-'}
        </span>
      ) : (
        <Link
          replace={false}
          to={{
            pathname: '/dashboard',
            search: `?vm=CATEGORIES&type=TABLE&pageSize=50&pageNumber=1&categoryId=${category.id}`,
          }}
          target="_blank"
        >
          <a className="external-link-wrapper" target="_blank" rel="noreferrer">
            <span className="link">{text}</span>
            <ExportOutlined
              color="#0077be"
              style={{ fontSize: '18px', marginLeft: '10px' }}
            />
          </a>
        </Link>
      )}
      <style jsx>{styles}</style>
    </>
  );
};

export default LinkToCategory;
